module.exports = __webpack_public_path__ + "img/145ne.e82797ff.svg";